/* ==========================================================================
   theme.js — GADLAB Shopify theme (real AJAX cart edition)
   --------------------------------------------------------------------------
   Ported from the static prototype. The in-memory cart is replaced with
   Shopify's AJAX Cart API (/cart/add.js, /cart/change.js, /cart.js).
   ========================================================================== */
(function () {
  "use strict";

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // Shopify money comes in the shop's minor unit (paise for INR)
  var money = function (cents) {
    return "₹" + (cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 });
  };

  /* ---- Sticky header shadow --------------------------------------------- */
  var header = $("[data-header]");
  if (header) {
    var onScroll = function () { header.setAttribute("data-stuck", window.scrollY > 8 ? "true" : "false"); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- Drawers ------------------------------------------------------------ */
  var overlay = $("[data-overlay]");
  var openDrawers = [];
  function openDrawer(drawer) {
    if (!drawer) return;
    drawer.setAttribute("data-open", "true");
    if (overlay) overlay.setAttribute("data-open", "true");
    document.body.style.overflow = "hidden";
    openDrawers.push(drawer);
  }
  function closeDrawers() {
    openDrawers.forEach(function (d) { d.setAttribute("data-open", "false"); });
    openDrawers = [];
    if (overlay) overlay.setAttribute("data-open", "false");
    document.body.style.overflow = "";
  }
  $$("[data-open-drawer]").forEach(function (btn) {
    btn.addEventListener("click", function () { openDrawer($("#" + btn.getAttribute("data-open-drawer"))); });
  });
  $$("[data-close-drawer]").forEach(function (btn) { btn.addEventListener("click", closeDrawers); });
  if (overlay) overlay.addEventListener("click", closeDrawers);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeDrawers(); });

  /* ---- AJAX cart ---------------------------------------------------------- */
  var cartBody = $("[data-cart-body]");
  var cartFoot = $("[data-cart-foot]");

  function renderCart(cart) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count ? "grid" : "none";
    });
    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<div class="cart-empty">Your bag is empty.<br>Add something to get started.</div>';
      if (cartFoot) cartFoot.style.display = "none";
      return;
    }
    if (cartFoot) cartFoot.style.display = "block";
    cartBody.innerHTML = cart.items.map(function (item, i) {
      return (
        '<div class="cart-line" data-line="' + (i + 1) + '">' +
          '<div class="cart-line__media">' + (item.image ? '<img src="' + item.image + '?width=112" alt="">' : "") + '</div>' +
          '<div>' +
            '<div class="cart-line__title">' + item.product_title + '</div>' +
            '<div class="cart-line__meta">' + (item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "") + '</div>' +
            '<div class="qty" style="margin-top:8px">' +
              '<button aria-label="Decrease" data-step="-1">−</button>' +
              '<input inputmode="numeric" value="' + item.quantity + '" aria-label="Quantity" readonly>' +
              '<button aria-label="Increase" data-step="1">+</button>' +
            '</div>' +
          '</div>' +
          '<div style="text-align:right">' +
            '<div class="cart-line__price">' + money(item.final_line_price) + '</div>' +
            '<button class="cart-line__remove" data-remove>Remove</button>' +
          '</div>' +
        '</div>'
      );
    }).join("");
    var sub = $("[data-cart-subtotal]");
    if (sub) sub.textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch("/cart.js").then(function (r) { return r.json(); }).then(renderCart);
  }

  function addItems(items) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return r.json().then(function (e) { throw new Error(e.description || "Could not add to bag"); });
      return refreshCart();
    }).then(function () { openDrawer($("#cart-drawer")); });
  }

  function getQty() {
    var qi = $("[data-qty-input]");
    return qi ? Math.max(1, parseInt(qi.value, 10) || 1) : 1;
  }

  // Add-to-bag buttons (cards, PDP, buybar)
  $$("[data-add]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var id = parseInt(btn.getAttribute("data-variant-id"), 10);
      if (!id) return;
      var qty = btn.hasAttribute("data-use-qty") ? getQty() : 1;
      btn.disabled = true;
      addItems([{ id: id, quantity: qty }])
        .catch(function (err) { alert(err.message); })
        .then(function () { btn.disabled = false; });
    });
  });

  // Buy now → add then go straight to checkout
  $$("[data-buy-now]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      e.preventDefault();
      var id = parseInt(btn.getAttribute("data-variant-id"), 10);
      if (!id) return;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: id, quantity: getQty() }] })
      }).then(function () { window.location.href = "/checkout"; });
    });
  });

  // Bundle: add both variants at once
  $$("[data-add-bundle]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var v1 = parseInt(btn.getAttribute("data-variant-1"), 10);
      var v2 = parseInt(btn.getAttribute("data-variant-2"), 10);
      if (!v1 || !v2) return;
      addItems([{ id: v1, quantity: 1 }, { id: v2, quantity: 1 }])
        .catch(function (err) { alert(err.message); });
    });
  });

  // Checkout button in drawer
  $$("[data-checkout]").forEach(function (btn) {
    btn.addEventListener("click", function () { window.location.href = "/checkout"; });
  });

  // Delegated qty steppers + remove inside drawer → /cart/change.js by line
  if (cartBody) {
    cartBody.addEventListener("click", function (e) {
      var lineEl = e.target.closest("[data-line]");
      if (!lineEl) return;
      var line = parseInt(lineEl.getAttribute("data-line"), 10);
      var input = lineEl.querySelector("input");
      var current = parseInt(input ? input.value : "1", 10) || 1;
      var next = null;
      if (e.target.hasAttribute("data-remove")) next = 0;
      else if (e.target.hasAttribute("data-step")) next = Math.max(0, current + parseInt(e.target.getAttribute("data-step"), 10));
      if (next === null) return;
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ line: line, quantity: next })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }

  /* ---- PDP: gallery ------------------------------------------------------- */
  // Slides are pre-rendered per product.media (images AND video); we only
  // toggle [hidden]. Swapping <img src> can't host a <video>, which is why the
  // uploaded video never showed before.
  var gallery = $("[data-gallery]");
  if (gallery) {
    var slides = $$("[data-gallery-slide]", gallery);
    var thumbs = $$("[data-gallery-thumb]", gallery);

    var showMedia = function (id) {
      slides.forEach(function (sl) {
        var on = sl.getAttribute("data-media-id") === id;
        if (!on) {
          var vid = sl.querySelector("video");
          if (vid && !vid.paused) vid.pause();
        }
        sl.hidden = !on;
      });
      thumbs.forEach(function (t) {
        var on = t.getAttribute("data-media-id") === id;
        t.setAttribute("aria-current", on ? "true" : "false");
        if (on && t.scrollIntoView) t.scrollIntoView({ block: "nearest", inline: "nearest", behavior: "smooth" });
      });
    };

    thumbs.forEach(function (t) {
      t.addEventListener("click", function () { showMedia(t.getAttribute("data-media-id")); });
    });
  }

  /* ---- PDP: variant matching BY OPTION VALUES ----------------------------- */
  var wrap = $("[data-product]");
  var variantsEl = wrap ? wrap.querySelector("[data-variants]") : null;
  if (variantsEl) {
    var variants = JSON.parse(variantsEl.textContent);
    var groups = $$("[data-option-group]", wrap);

    function selectedOptions() {
      return groups.map(function (g) {
        var on = g.querySelector('.swatch[aria-pressed="true"]');
        return on ? on.getAttribute("data-option-value") : null;
      });
    }
    function findVariant(opts) {
      return variants.filter(function (v) {
        return opts.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
    }
    function applyVariant(v) {
      if (!v) return;
      $$("[data-add],[data-buy-now]").forEach(function (b) {
        b.setAttribute("data-variant-id", v.id);
        b.disabled = !v.available;
      });
      // keep the Fastrr /cart/add form in sync
      var srVar = $("[data-sr-variant]");
      if (srVar) srVar.value = v.id;
      var p = $("[data-price]"), c = $("[data-compare]"), s = $("[data-save]"), pb = $("[data-price-bar]");
      if (p) p.textContent = money(v.price);
      if (pb) pb.textContent = money(v.price);
      if (c) {
        if (v.compare_at_price > v.price) { c.style.display = ""; c.textContent = money(v.compare_at_price); }
        else c.style.display = "none";
      }
      if (s) {
        if (v.compare_at_price > v.price) { s.style.display = ""; s.textContent = "Save " + money(v.compare_at_price - v.price); }
        else s.style.display = "none";
      }
    }
    groups.forEach(function (g) {
      $$(".swatch", g).forEach(function (sw) {
        sw.addEventListener("click", function () {
          $$(".swatch", g).forEach(function (x) { x.setAttribute("aria-pressed", "false"); });
          sw.setAttribute("aria-pressed", "true");
          var label = g.querySelector("[data-option-label]");
          if (label) label.textContent = sw.getAttribute("data-option-value");
          applyVariant(findVariant(selectedOptions()));
        });
      });
    });
  }

  /* ---- PDP: quantity stepper ---------------------------------------------- */
  var qIn = $("[data-qty-input]");
  if (qIn) {
    var setQ = function (v) {
      qIn.value = Math.max(1, v || 1);
      var srQty = $("[data-sr-qty]");
      if (srQty) srQty.value = qIn.value;   // keep Fastrr form in sync
    };
    var qDec = $("[data-qty-dec]"), qInc = $("[data-qty-inc]");
    if (qDec) qDec.addEventListener("click", function () { setQ((parseInt(qIn.value, 10) || 1) - 1); });
    if (qInc) qInc.addEventListener("click", function () { setQ((parseInt(qIn.value, 10) || 1) + 1); });
  }

  /* ---- Hero slider --------------------------------------------------------- */
  // Layout is CSS scroll-snap (native swipe). JS adds autoplay, dots, arrows,
  // and theme-editor hooks. Index is derived from scroll position so touch,
  // trackpad, and button navigation all stay in sync.
  var initHeroSlider = function (root) {
    var track = $("[data-hero-track]", root);
    var slides = $$("[data-hero-slide]", root);
    if (!track || slides.length < 2 || root.__heroInit) return;
    root.__heroInit = true;

    var dots = $$("[data-hero-dot]", root);
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var interval = parseInt(root.getAttribute("data-interval"), 10) || 5000;
    var autoplay = root.getAttribute("data-autoplay") === "true" && !reduced;
    var timer = null, current = 0, paused = false;

    var setActive = function (i) {
      current = i;
      dots.forEach(function (d, k) { d.setAttribute("aria-selected", k === i ? "true" : "false"); });
    };
    var goTo = function (i, instant) {
      var n = slides.length, idx = ((i % n) + n) % n;
      track.scrollTo({ left: slides[idx].offsetLeft, behavior: instant || reduced ? "auto" : "smooth" });
      setActive(idx);
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () {
      if (!autoplay || paused || timer || document.hidden) return;
      timer = setInterval(function () { goTo(current + 1); }, interval);
    };
    var restart = function () { stop(); start(); };   // manual nav resets the clock, never kills it

    // Sync dots to whatever slide is actually in view (swipe/trackpad).
    var raf = null;
    track.addEventListener("scroll", function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = null;
        var w = track.clientWidth || 1;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current && i >= 0 && i < slides.length) setActive(i);
      });
    }, { passive: true });

    dots.forEach(function (d, k) { d.addEventListener("click", function () { goTo(k); restart(); }); });
    var prev = $("[data-hero-prev]", root), next = $("[data-hero-next]", root);
    if (prev) prev.addEventListener("click", function () { goTo(current - 1); restart(); });
    if (next) next.addEventListener("click", function () { goTo(current + 1); restart(); });

    // Only hold while a finger is actually on the track, or the tab is hidden.
    // (No hover/focus pausing: a mouse resting on the hero must not stop it.)
    track.addEventListener("touchstart", stop, { passive: true });
    track.addEventListener("touchend", restart, { passive: true });
    track.addEventListener("touchcancel", restart, { passive: true });
    document.addEventListener("visibilitychange", function () { document.hidden ? stop() : start(); });

    // Keep the current slide aligned if the viewport is resized.
    var rt = null;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () { goTo(current, true); }, 120);
    });

    // Theme editor: jump to the block being edited, and hold there.
    document.addEventListener("shopify:block:select", function (e) {
      var slide = e.target && e.target.closest ? e.target.closest("[data-hero-slide]") : null;
      var i = slide ? slides.indexOf(slide) : -1;
      if (i > -1) { paused = true; stop(); goTo(i, true); }
    });
    document.addEventListener("shopify:block:deselect", function () { paused = false; start(); });

    start();
  };
  $$("[data-hero-slider]").forEach(initHeroSlider);
  document.addEventListener("shopify:section:load", function (e) {
    $$("[data-hero-slider]", e.target).forEach(initHeroSlider);
  });

  /* ---- Shoppable video ---------------------------------------------------- */
  // Tiles autoplay muted while ≥60% visible; a tap opens a lightbox that clones
  // the tile's <video> (unmuted, controls) + product chip. Quick-add inside the
  // lightbox is delegated to the same addItems() the cards use.
  var initShoppableVideo = function (root) {
    if (root.__svidInit) return;
    root.__svidInit = true;
    var rail = $("[data-svid-rail]", root);
    var tiles = $$("[data-svid-tile]", root);
    var lb = $("[data-svid-lb]", root);
    var lbVideo = $("[data-svid-lb-video]", root);
    var lbProd = $("[data-svid-lb-prod]", root);
    if (!rail || !tiles.length) return;

    var tryPlay = function (v) {
      v.muted = true;                       // muted is the autoplay contract
      var pr = v.play();
      if (pr && pr.catch) pr.catch(function () {
        // Not ready yet (still processing / buffering) → retry once playable.
        if (v.__svidRetry) return;
        v.__svidRetry = true;
        v.addEventListener("canplay", function again() {
          v.removeEventListener("canplay", again);
          v.__svidRetry = false;
          if (v.__svidInView) { var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); }
        });
      });
    };
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    // In-view autoplay (muted). Native `autoplay` attr starts them without JS;
    // this keeps only visible clips running to save bandwidth.
    if ("IntersectionObserver" in window && !reduced) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var v = en.target.querySelector("video");
          if (!v) return;
          v.__svidInView = en.isIntersecting && en.intersectionRatio >= 0.35;
          if (v.__svidInView) tryPlay(v); else v.pause();
        });
      }, { threshold: [0, 0.35] });
      tiles.forEach(function (t) { io.observe(t); });
    } else if (!reduced) {
      tiles.forEach(function (t) { var v = t.querySelector("video"); if (v) { v.__svidInView = true; tryPlay(v); } });
    }

    // Arrows (desktop)
    var step = function () { var t = tiles[0]; return t ? t.getBoundingClientRect().width + 16 : 300; };
    var prev = $("[data-svid-prev]", root), next = $("[data-svid-next]", root);
    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step() * 2, behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step() * 2, behavior: "smooth" }); });

    // Lightbox
    var lastFocus = null;
    var closeLb = function () {
      if (!lb || lb.hidden) return;
      lb.hidden = true;
      lbVideo.innerHTML = ""; lbProd.innerHTML = "";
      document.documentElement.style.overflow = "";
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    };
    var openLb = function (tile) {
      if (!lb) return;
      var src = tile.querySelector("video");
      if (!src) return;
      tiles.forEach(function (t) { var v = t.querySelector("video"); if (v) v.pause(); });
      var v = src.cloneNode(true);
      v.removeAttribute("loop"); v.controls = true; v.muted = false; v.autoplay = true; v.playsInline = true;
      v.setAttribute("preload", "auto");
      lbVideo.innerHTML = ""; lbVideo.appendChild(v);
      var chip = tile.querySelector("[data-svid-prod]");
      lbProd.innerHTML = ""; if (chip) lbProd.appendChild(chip.cloneNode(true));
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.documentElement.style.overflow = "hidden";
      tryPlay(v);
      var c = $("[data-svid-close]", lb); if (c && c.focus) c.focus();
    };
    tiles.forEach(function (t) {
      var b = t.querySelector("[data-svid-open]");
      if (b) b.addEventListener("click", function () { openLb(t); });
    });
    if (lb) {
      $$("[data-svid-close]", lb).forEach(function (c) { c.addEventListener("click", closeLb); });
      // Delegated quick-add for the cloned chip (clones carry no listeners)
      lbProd.addEventListener("click", function (e) {
        var btn = e.target.closest ? e.target.closest("[data-add]") : null;
        if (!btn) return;
        e.preventDefault();
        var id = parseInt(btn.getAttribute("data-variant-id"), 10);
        if (!id) return;
        btn.disabled = true;
        addItems([{ id: id, quantity: 1 }])
          .then(closeLb)
          .catch(function (err) { console.error("[svid] add failed:", err.message); })
          .then(function () { btn.disabled = false; });
      });
      document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeLb(); });
    }

    // Theme editor: bring the selected clip into view
    document.addEventListener("shopify:block:select", function (e) {
      var tile = e.target && e.target.closest ? e.target.closest("[data-svid-tile]") : null;
      if (tile && root.contains(tile)) tile.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" });
    });
  };
  $$("[data-svid]").forEach(initShoppableVideo);
  document.addEventListener("shopify:section:load", function (e) {
    $$("[data-svid]", e.target).forEach(initShoppableVideo);
  });

  /* ---- Wishlist toggle (visual only) --------------------------------------- */
  $$("[data-wish]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      b.setAttribute("aria-pressed", b.getAttribute("aria-pressed") === "true" ? "false" : "true");
    });
  });
})();
